module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "quitsuccess"
  }, [_vm._v("\n      您的申请已经提交，系统正在处理，稍后您可以在订单详情页查看结果。感谢您对美心的支持！\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确定",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71670f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/quitsuccess.vue
// module id = 411
// module chunks = 68